<script setup lang="ts">
import { watch } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useToastStore } from '@/stores/toast';
import ToastHost from '@/components/ui/ToastHost.vue';
import ConfirmHost from '@/components/ui/ConfirmHost.vue';

const auth = useAuthStore();
const toast = useToastStore();
const router = useRouter();

// When a refresh fails mid-session, send the user to sign in and bring them back afterwards.
watch(
  () => auth.sessionExpired,
  (expired) => {
    if (!expired) return;
    toast.warning('Your session has ended', 'Please sign in again.');
    void router.push({ path: '/login', query: { redirect: router.currentRoute.value.fullPath } });
  },
);
</script>

<template>
  <RouterView />
  <ToastHost />
  <ConfirmHost />
</template>
